import React from 'react';
import { Package, Phone, Instagram, Facebook, Mail, User } from 'lucide-react';

const Header = () => {
  const whatsappNumber = '50688937777';
  const whatsappLink = `https://wa.me/${whatsappNumber}`;

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header className="sendhapy-header">
      <div className="sendhapy-header-content">
        <a href="/" className="sendhapy-logo">
          <img 
            src="/sendhapy-logo-badge.png"
            alt="SendHapy Logo"
            className="h-11 md:h-12 w-auto my-2"
            data-testid="header-logo"
          />
        </a>
        
        <nav className="hidden md:flex items-center gap-6">
          <button 
            onClick={() => scrollToSection('tracking')}
            className="text-base font-medium text-gray-700 hover:text-gray-900 transition-colors"
          >
            Tracking
          </button>
          <button 
            onClick={() => scrollToSection('casillero')}
            className="text-base font-medium text-gray-700 hover:text-gray-900 transition-colors"
          >
            Casillero
          </button>
          <button 
            onClick={() => scrollToSection('contacto')}
            className="text-base font-medium text-gray-700 hover:text-gray-900 transition-colors"
          >
            Contacto
          </button>
        </nav>

        <div className="flex items-center gap-3">
          <a 
            href="/cliente"
            className="flex items-center gap-2 px-4 py-2 rounded-lg font-medium text-sm transition-all hover:opacity-90"
            style={{ background: 'var(--sendhapy-teal)', color: 'white' }}
          >
            <User size={18} />
            <span className="hidden sm:inline">Mi Cuenta</span>
          </a>
          <a 
            href="https://instagram.com/send.hapy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-600 hover:text-pink-600 transition-colors"
            aria-label="Instagram"
          >
            <Instagram size={22} />
          </a>
          <a 
            href="https://facebook.com/profile.php?id=61553931707213"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-600 hover:text-blue-600 transition-colors"
            aria-label="Facebook"
          >
            <Facebook size={22} />
          </a>
          <a 
            href="mailto:hola@sendhapy.com"
            className="text-gray-600 hover:text-teal-600 transition-colors"
            aria-label="Email"
          >
            <Mail size={22} />
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
